import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import type { IconCircleColors, IconCircleSizes } from './icon-circle';

const colors = (theme: Theme, color: IconCircleColors) =>
  ({
    primary: css`
      background-color: ${theme.palette.primary.mainContrast};
    `,
    success: css`
      background-color: ${theme.palette.success.lowContrast};
    `,
    warning: css`
      background-color: ${theme.palette.warning.lowContrast};
    `,
    error: css`
      background-color: ${theme.palette.error.lowContrast};
    `,
    gray: css`
      background-color: ${theme.palette.disabled.main};
    `,
    actionPrimary: css`
      background-color: ${theme.palette.secondary.mainContrast};
    `,
    secondary: css`
      background-color: ${theme.palette.primary.lowContrast};
    `,
    reversedContrast: css`
      background-color: ${theme.palette.secondary.reversedContrast};
    `,
    additional: css`
      background-color: ${theme.palette.secondary.mediumContrast};
    `,
    disabled: css`
      background-color: ${theme.palette.disabled.main};
    `,
  })[color];

export const root = (theme: Theme, color: IconCircleColors, iconSize: IconCircleSizes) => css`
  display: flex;
  justify-content: center;
  align-items: center;

  height: ${theme.spacing[iconSize]};
  width: ${theme.spacing[iconSize]};
  border-radius: ${theme.borderRadius.circle};

  ${colors(theme, color)};
`;
